/* Reopen Shopify's own preferences modal; never mount a second consent banner.
 * https://shopify.dev/docs/api/customer-privacy#cookie-banner-api
 */
(() => {
  'use strict';
  if (window.__kinmiluPrivacyControlsStarted) return;
  window.__kinmiluPrivacyControlsStarted = true;
  const libraryUrl = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
  let libraryPromise;
  const banner = () => typeof window.privacyBanner?.showPreferences === 'function' ? window.privacyBanner : null;

  const loadBannerLibrary = () => {
    if (banner()) return Promise.resolve(banner());
    if (libraryPromise) return libraryPromise;
    libraryPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${libraryUrl}"]`);
      const script = existing || document.createElement('script');
      let timer;
      const clean = () => {
        clearTimeout(timer);
        script.removeEventListener('load', loaded);
        script.removeEventListener('error', failed);
      };
      const failed = () => {
        clean();
        if (!existing) script.remove();
        reject(new Error('Cookie preferences unavailable'));
      };
      const loaded = () => {
        if (!banner()) { failed(); return; }
        clean();
        resolve(banner());
      };
      timer = setTimeout(failed, 10000);
      script.addEventListener('load', loaded, { once: true });
      script.addEventListener('error', failed, { once: true });
      if (!existing) {
        script.src = libraryUrl;
        script.async = true;
        document.head.appendChild(script);
      }
    }).catch((error) => { libraryPromise = null; throw error; });
    return libraryPromise;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-cookie-preferences]');
    if (!button || button.disabled) return;
    const status = button.closest('.kinmilu-cookie-control')?.querySelector('[data-cookie-settings-status]');
    button.disabled = true;
    if (status) { status.hidden = false; status.textContent = 'Opening cookie settings…'; }
    try {
      const privacyBanner = await loadBannerLibrary();
      await privacyBanner.showPreferences();
      if (status) { status.hidden = true; status.textContent = ''; }
    } catch (_) {
      if (status) { status.hidden = false; status.textContent = 'Cookie settings could not load. Please try again.'; }
    } finally { button.disabled = false; }
  });
})();
